import React, { useContext, useEffect, useState } from "react";
import ReportsPage from "./Report";
import { BsFiletypePdf, BsFileEarmarkExcel } from "react-icons/bs";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import {
  SecurityQuestionRequestArray,
  partners,
} from "../../lib/interfaces/index";
import { AutoLogout } from "../../components/AutoLogoutComponent";
import {
  generateLoading,
  showAlert,
  stopLoading,
} from "../../promptMessages/PromptMessages";
import { AuthContext } from "../../components/AuthContextComponent";
import {
  formatDateTimeUS,
  FormatNumber,
  Formatter,
} from "../../lib/formatter/Formatter";
import { ALERTMSG, STATUS } from "../../lib/enums/index";
import { useManualUpload, usePagination, useTheme } from "../../hooks/index";
import Header from "../../components/HeaderComponent";
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
} from "../../components/table/index";
import Pagination from "../../components/pagination/Pagination";
import { forgetPassword } from "../../api/FetchAPI";
import SecurityQuestion from "../../components/SecurityQuestion";
import UpdatePassword from "../../components/updatepassword/UpdatePassword";
import LoadingComponent from "../../components/loading/Loading";
import useHeadComponent from "../../hooks/HeaderHook";
import useUserLogin from "../../hooks/UserLoginhook";
import { useCustomAccount } from "../../components/CustomAccountContext";
import { mlBannerBase64 } from "../../lib/constants/MLBannerBase64";
import TotalDisplay from "../../components/grid/TotalDisplay";
import { GeneratePDF } from "../../lib/helpers/GeneratePDFReport";
import { blobToBase64, urlToBlob } from "../../lib/helpers/ImageConverter";
import { getPartnerNameById } from "../../lib/helpers/Helpers";
import { FetchErr } from "../../lib/helpers/UnhandledError";
import { FaRegFileExcel } from "react-icons/fa";
import { GenerateXlsxReport } from "../../lib/helpers/GenerateExcelReport";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const Reports = () => {
  const userInfo = useContext(AuthContext);
  const { username, setPartnerName } = useContext(AuthContext);
  const { customAccount } = useCustomAccount();
  const { customColor } = useUserLogin();
  const [headers, setHeaders] = useState<any>();
  const [lists, setLists] = useState<any>();
  const [isOpen, setIsOpen] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [totalPHP, setTotalPHP] = useState<any>();
  const [totalFeePHP, setTotalFeePHP] = useState<any>();
  const [totalPrincipalPHP, setTotalPrincipalPHP] = useState<any>();
  const [totalUSD, setTotalUSD] = useState<any>();
  const [totalPrincipalUSD, setTotalPrincipalUSD] = useState<any>();
  const [totalFeeUSD, setTotalFeeUSD] = useState<any>();
  const [date, setPdfDate] = useState("");
  const [dateRangeFrom, setPdfDateRangeFrom] = useState("");
  const [dateRangeTo, setPdfDateRangeTo] = useState("");
  const [batchNumber, setPdfBatchNumber] = useState("");
  const [selectedpartner, setSelectedPartner] = useState<number>();
  const [partners, setPartners] = useState<partners[] | null>(null);
  const themeBackground = userInfo.userInfo?.theme === "DARK" ? "#24292e" : "";
  const themeTextColor = userInfo.userInfo?.theme === "DARK" ? "#fafbfc" : "";
  const lname = userInfo.userInfo?.userLName || "";
  const fname = userInfo.userInfo?.userFName || "";
  const mname = userInfo.userInfo?.userMName || "";
  const fullName = `${lname}, ${fname}${mname ? " " + mname : ""}`.trim();
  const now = new Date();
  const { openOTP, selectedPartner } = useManualUpload();
  const { Balance } = useHeadComponent(selectedPartner);
  const headerList = headers || [];
  const reportDataList = lists || [];
  const itemsPerPage = 15;

  const formattedDateTime = formatDateTimeUS(now);
  const { theme } = useTheme();
  const [redirectModal, setRedirectModal] = useState(false);
  const [currentQuestions, setCurrentQuestions] =
    useState<SecurityQuestionRequestArray | null>(null);

  const {
    currentItems,
    currentPage,
    totalPages,
    handlePageChange,
    setCurrentPage,
  } = usePagination(reportDataList);

  const { pwdUpdate, category } = userInfo.userInfo || {};

  const redirectState = !!(redirectModal && category === "EXTERNAL");

  const firstTimeLoginState = !!(pwdUpdate && category === "EXTERNAL");

  let reportPartnerName = "";

  if (userInfo.userInfo?.category === STATUS.INTERNAL) {
    reportPartnerName = getPartnerNameById(selectedpartner, partners) || "";
  } else {
    reportPartnerName = userInfo.userInfo?.partnersName || "";
  }

  const [base64, setBase64] = useState<string | null>(null);

  useEffect(() => {
    const convertImage = async () => {
      if (customAccount?.reportImage) {
        try {
          const blob = await urlToBlob(customAccount.reportImage);
          const base64String = await blobToBase64(blob);
          setBase64(base64String);
        } catch (error) {
          console.error(error);
        }
      }
    };

    convertImage();
  }, [customAccount]);

  const customBase64: any = base64;

  //handle for generation of pdf report
  const handleGeneratePDF = async () => {
    generateLoading(ALERTMSG.LOADING, themeBackground, themeTextColor);

    await new Promise<void>((resolve) => {
      setTimeout(async () => {
        await GeneratePDF({
          lists,
          headers,
          date,
          dateRangeFrom,
          dateRangeTo,
          batchNumber,
          reportPartnerName,
          fullName,
          formattedDateTime,
          customBase64,
          mlBannerBase64,
          totalPHP,
          totalUSD,
          totalPrincipalPHP,
          totalPrincipalUSD,
          totalFeePHP,
          totalFeeUSD,
          username,
        });

        setIsOpen(false);

        resolve();
      }, 1000);
    });

    stopLoading();
  };

  //handle for generation of xlsx report
  const handleGenerateXlsx = async () => {
    generateLoading(ALERTMSG.LOADING, themeBackground, themeTextColor);
    await new Promise<void>((resolve) => {
      setTimeout(async () => {
        await GenerateXlsxReport({
          lists,
          headers,
          date,
          dateRangeFrom,
          dateRangeTo,
          batchNumber,
          reportPartnerName,
          fullName,
          formattedDateTime,
          customBase64,
          mlBannerBase64,
          totalPHP,
          totalUSD,
          totalPrincipalPHP,
          totalPrincipalUSD,
          totalFeePHP,
          totalFeeUSD,
          username,
        });

        setIsOpen(false);

        resolve();
      }, 1000);
    });

    stopLoading();
  };

  useEffect(() => {
    const fetchCurrentUserQuestion = async () => {
      // try {
      const response: any = await forgetPassword(username);

      const { respCode, respMsg, questionInfo } = response;

      if (respCode === 2000) {
        if (questionInfo === null || questionInfo < 2) {
          setCurrentQuestions(null);

          setRedirectModal(true);
        } else {
          setCurrentQuestions(questionInfo);
        }
      } else {
        showAlert(
          ALERTMSG.SOMEWENTWRONG,
          `${respMsg} (${respCode})`,
          "error",
          customColor,
          themeBackground,
          themeTextColor,
        );
      }
      // } catch (error: any) {
      //   FetchErr(error, themeBackground, customColor, themeTextColor);
      // }
    };

    let count = 0;
    if (count === 0) {
      const timer = setTimeout(() => {
        fetchCurrentUserQuestion();
      }, 1000);
      count++;
      return () => clearTimeout(timer);
    }
  }, [username]);

  const renderConditionalComponent = () => {
    if (pwdUpdate && category === STATUS.EXTERNAL) {
      return <UpdatePassword />;
    } else if (redirectModal && category === STATUS.EXTERNAL) {
      return <SecurityQuestion />;
    }
    return null; // Return null if neither condition is met
  };

  return (
    <div className="font-sans">
      <Header Balance={Balance} theme={theme}></Header>

      <AutoLogout
        openOTP={openOTP}
        redirectModal={redirectState}
        redirectChangePassword={firstTimeLoginState}
      />

      <ReportsPage
        setHeaders={setHeaders}
        setLists={setLists}
        setTotalPHP={setTotalPHP}
        setTotalPrincipalPHP={setTotalPrincipalPHP}
        setTotalFeePHP={setTotalFeePHP}
        setTotalUSD={setTotalUSD}
        setTotalPrincipalUSD={setTotalPrincipalUSD}
        setTotalFeeUSD={setTotalFeeUSD}
        setPdfDate={setPdfDate}
        setPdfDateRangeFrom={setPdfDateRangeFrom}
        setPdfDateRangeTo={setPdfDateRangeTo}
        setPdfBatchNumber={setPdfBatchNumber}
        setIsOpen={setIsOpen}
        setIsGenerating={setIsGenerating}
        setCurrentPage={setCurrentPage}
        setSelectedPartner={setSelectedPartner}
        selectedpartner={selectedpartner}
        setPartners={setPartners}
        partners={partners}
      ></ReportsPage>

      <div className="flex flex-wrap justify-center w-full">
        {isGenerating ? (
          <div className="flex items-center justify-center w-screen h-[350px] md:mt-44">
            <LoadingComponent customColor={customColor} />
          </div>
        ) : (
          <></>
        )}

        {isOpen ? (
          <>
            <Table>
              <TableHeader>
                <TableRow
                  data={headerList.map((header: any) => header.label)}
                  isHeader
                />
              </TableHeader>
              <TableBody>
                {currentItems.map((reportData: any, index: any) => (
                  <TableRow key={index} data={Object.values(reportData)} />
                ))}
              </TableBody>
            </Table>

            {headerList && lists ? (
              <>
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                  isReport
                />

                <div className="flex flex-col flex-wrap items-center justify-center w-full gap-5 py-2 mx-auto font-sans transition-all duration-1000 ease-in-out md:justify-between text-custom-petite md:flex-row md:gap-10">
                  <div
                    className={`text-md flex md:gap-10 gap-10 px-9 ${
                      userInfo.userInfo?.theme === "DARK"
                        ? "text-white"
                        : "text-black"
                    }`}
                  >
                    <div className="flex flex-col gap-1 text-xs md:gap-2 md:w-96 md:text-custom-petite">
                      <TotalDisplay
                        label="Total Count (PHP) :"
                        value={`${Formatter(totalPHP)}`}
                      />

                      <TotalDisplay
                        label="Total Principal (PHP) :"
                        value={`PHP ${FormatNumber(totalPrincipalPHP)}`}
                      />

                      <TotalDisplay
                        label="Total Charges (PHP) :"
                        value={`PHP ${FormatNumber(totalFeePHP)}`}
                      />
                    </div>

                    <div className="flex flex-col gap-1 text-xs md:gap-2 md:w-96 md:text-custom-petite">
                      <TotalDisplay
                        label="Total Count (USD) :"
                        value={`${Formatter(totalUSD)}`}
                      />

                      <TotalDisplay
                        label="Total Principal (USD) :"
                        value={`USD ${FormatNumber(totalPrincipalUSD)}`}
                      />

                      <TotalDisplay
                        label="Total Charges (USD) :"
                        value={`USD ${FormatNumber(totalFeeUSD)}`}
                      />
                    </div>
                  </div>

                  <div className="flex px-10 lg:px-0">
                    <button
                      onClick={handleGeneratePDF}
                      style={{
                        backgroundColor: customColor,
                      }}
                      className={`flex items-center justify-center py-2 w-[135px] h-[30px] bg-custom-default text-white rounded-md mr-10 gap-2 text-custom-micro ${
                        customColor
                          ? `hover:scale-105 transition-all duration-300`
                          : `hover:bg-custom-default-hover hover:shadow-lg hover:shadow-red-500/40`
                      }`}
                    >
                      <BsFiletypePdf className="text-custom-micro" /> Generate
                      PDF
                    </button>
                    <button
                      onClick={handleGenerateXlsx}
                      style={{
                        backgroundColor: customColor,
                      }}
                      className={`flex items-center justify-center py-2 w-[135px] h-[30px] bg-custom-default text-white rounded-md mr-10 gap-2 text-custom-micro ${
                        customColor
                          ? `hover:scale-105 transition-all duration-300`
                          : `hover:bg-custom-default-hover hover:shadow-lg hover:shadow-red-500/40`
                      }`}
                    >
                      <BsFileEarmarkExcel className="text-custom-micro" />
                      Generate Excel
                    </button>
                  </div>
                </div>
              </>
            ) : null}
          </>
        ) : null}
      </div>

      {renderConditionalComponent()}
    </div>
  );
};

export default Reports;
